import { ConfigFlagsState } from './configFlagsTypes';

export const CONFIG_FLAGS_SLICE_NAME = 'configFlags';

export const CONFIG_FLAGS_INITIAL_STATE: ConfigFlagsState = {
  values: {},
  status: 'idle',
};
